import includes from 'lodash/includes';
import kebabCase from 'lodash/kebabCase';
import last from 'lodash/last';
import { latinize } from './latin.string.helper';

export function replaceTextBreaksWithBrs(text: string, uniteBreaks: boolean = false): string {
  if (!text) {
    return '';
  }

  const br = '<br />';
  const n = '\n';

  if (uniteBreaks) {
    text.replace(/\n\s*\n/g, n)
      .replace(/(\n){2,}/g, n + n);
  }
  return text
    .replace(/\n/g, br);
}


export function replaceBrsWithTextBreaks(text: string, uniteBreaks: boolean = false): string {
  if (!text) {
    return '';
  }

  const brRegex = /<br\s*\/>/g;
  const n = '\n';

  text = text
    .replace(brRegex, n);

  if (uniteBreaks) {
    text = text.replace(/\n\s*\n/g, n)
      .replace(/(\n){2,}/g, n);
  }

  return text;
}

export const getLineBreakersQuantity = (text: string): number => {
  return (text || '')
    .split('')
    .filter((l) => includes(l, '\n'))
    .length || 0;
};

export const getLengthWithoutLineBreakers = (text: string): number => {
  return (text || '').replace(/\n/g, '').length;
};

export function generateNameId(name: string, id: number): string {
  return `${latinize(kebabCase(name))}-${id}`;
}

export function getIdFromNameId(nameId: string): number {
  return +last(nameId.split('-'));
}

export const stringHelper = {
  replaceTextBreaksWithBrs,
  replaceBrsWithTextBreaks,
  getLineBreakersQuantity,
  getLengthWithoutLineBreakers,

  generateNameId,
  getIdFromNameId,
};
